import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFocusFrameMXxl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.58433e-06 3.05979e-07H40V6H3.58433e-06V3.05979e-07Z",
		fill: "#E7392D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 0L6 40H0L3.58433e-06 3.05979e-07L6 0Z",
		fill: "#E7392D"
	})]
});
export default SvgFocusFrameMXxl;
